import { SuggestedQuestion } from 'src/app/models/report-assistant.model';

/** Condition areas of the report: key in `ratings` + display label. */
export const REPORT_CATEGORIES = [
  { key: 'exterior', label: 'Exterior' },
  { key: 'interior', label: 'Interior' },
  { key: 'mechanics', label: 'Mechanics' },
  { key: 'frame', label: 'Frame' },
  { key: 'major_options', label: 'Major Options' }
];

export const SUGGESTED_QUESTIONS: SuggestedQuestion[] = [
  { icon: 'summary', text: 'Give me a quick summary of this car' },
  { icon: 'price', text: 'Is the asking price fair?' },
  { icon: 'defect', text: 'What are the biggest defects?' },
  { icon: 'wrench', text: 'How much will repairs cost?' },
  { icon: 'parts', text: 'How is the exterior, interior and mechanics?' },
  { icon: 'bid', text: 'Should I bid on this car?' }
];
